var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "账单明细",
        visible: _vm.dialogVisible,
        width: "90%",
        "close-on-click-modal": false,
        "custom-class": "bill-items-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "bill-info" }, [
        _c("p", [_vm._v("商家类型：" + _vm._s(_vm.billInfo.merchantType))]),
        _vm._v(" "),
        _c("p", [_vm._v("商家名称：" + _vm._s(_vm.billInfo.merchantName))]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "对账周期：" +
              _vm._s(_vm.billInfo.periodStart) +
              " 至 " +
              _vm._s(_vm.billInfo.periodEnd)
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "batch-actions" },
        [
          _c("el-button", { attrs: { type: "success", size: "small" } }, [
            _vm._v("将筛选结果全部添加至对账单"),
          ]),
          _vm._v(" "),
          _c("el-button", { attrs: { type: "warning", size: "small" } }, [
            _vm._v("将筛选结果从对账单中移除"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          attrs: { inline: "", size: "small", "label-width": "80px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "交易单号:" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: { placeholder: "请输入", clearable: "" },
                model: {
                  value: _vm.searchForm.tradeNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "tradeNo", $$v)
                  },
                  expression: "searchForm.tradeNo",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "订单号:" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: { placeholder: "请输入", clearable: "" },
                model: {
                  value: _vm.searchForm.orderNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "orderNo", $$v)
                  },
                  expression: "searchForm.orderNo",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "下单时间:" } },
            [
              _c("el-date-picker", {
                staticClass: "time-picker",
                attrs: {
                  type: "datetime",
                  placeholder: "开始时间",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                },
                model: {
                  value: _vm.searchForm.orderTimeStart,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "orderTimeStart", $$v)
                  },
                  expression: "searchForm.orderTimeStart",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "time-separator" }, [_vm._v("至")]),
              _vm._v(" "),
              _c("el-date-picker", {
                staticClass: "time-picker",
                attrs: {
                  type: "datetime",
                  placeholder: "结束时间",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                },
                model: {
                  value: _vm.searchForm.orderTimeEnd,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "orderTimeEnd", $$v)
                  },
                  expression: "searchForm.orderTimeEnd",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "订单状态:" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "selWidth",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.searchForm.orderStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "orderStatus", $$v)
                    },
                    expression: "searchForm.orderStatus",
                  },
                },
                [_c("el-option", { attrs: { label: "已完结", value: "1" } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "*销售方法:" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "selWidth",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.searchForm.saleMethod,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "saleMethod", $$v)
                    },
                    expression: "searchForm.saleMethod",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "线上", value: "1" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "线下", value: "2" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "订单类型:" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "selWidth",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.searchForm.orderType,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "orderType", $$v)
                    },
                    expression: "searchForm.orderType",
                  },
                },
                [_c("el-option", { attrs: { label: "普通订单", value: "1" } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否加入对账单:" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "selWidth",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.searchForm.isInBill,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "isInBill", $$v)
                    },
                    expression: "searchForm.isInBill",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "是", value: "1" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "否", value: "0" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c("el-button", { attrs: { type: "primary", size: "small" } }, [
                _vm._v("搜索"),
              ]),
              _vm._v(" "),
              _c("el-button", { attrs: { size: "small" } }, [_vm._v("重置")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticClass: "table",
          attrs: {
            data: _vm.tableData.list,
            size: "mini",
            "highlight-current-row": "",
            "header-cell-style": { fontWeight: "bold" },
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "tradeNo", label: "交易单号", "min-width": "140" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "platformOrderNo",
              label: "平台订单号",
              "min-width": "140",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "merchantOrderNo",
              label: "商家订单号",
              "min-width": "100",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "销售属性", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticClass: "sale-attr" }, [
                      _vm._v(_vm._s(scope.row.saleAttr)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "订单金额", "min-width": "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        ¥" + _vm._s(scope.row.orderAmount) + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "成交结算金额", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        ¥" +
                        _vm._s(scope.row.settledAmount) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "实际结算金额", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        ¥" +
                        _vm._s(scope.row.actualAmount) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "核实金额", "min-width": "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        ¥" +
                        _vm._s(scope.row.verifiedAmount) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "orderStatus",
              label: "订单状态",
              "min-width": "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否加入账单", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.isInBill ? "是" : "否")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "orderTime", label: "下单时间", "min-width": "150" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "reconciliationRemark",
              label: "对账备注",
              "min-width": "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "financeRemark",
              label: "财务备注",
              "min-width": "80",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", "min-width": "120", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "operation-group" },
                      [
                        scope.row.isInBill
                          ? [
                              _c(
                                "el-button",
                                { attrs: { type: "text", size: "small" } },
                                [_vm._v("编辑明细")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                { attrs: { type: "text", size: "small" } },
                                [_vm._v("财务备注")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                { attrs: { type: "text", size: "small" } },
                                [_vm._v("对账备注")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "text-warning",
                                  attrs: { type: "text", size: "small" },
                                },
                                [_vm._v("从对账单移除")]
                              ),
                            ]
                          : [
                              _c(
                                "el-button",
                                {
                                  staticClass: "text-success",
                                  attrs: { type: "text", size: "small" },
                                },
                                [_vm._v("添加至对账单")]
                              ),
                            ],
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "pagination",
        attrs: {
          "current-page": _vm.searchForm.page,
          "page-sizes": [20, 50, 100],
          "page-size": _vm.searchForm.limit,
          layout: "total, prev, pager, next, sizes",
          total: _vm.tableData.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }